import { db } from './../../config/Fire';
import * as Constants from './../../constants/nodes_database';

export const SET_SERVICES_ADMIN = 'SET_SERVICES_ADMIN';

const setServicesAdmin = payload => ({ type: SET_SERVICES_ADMIN, payload });

export const setServicesAdminToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.SERVICES}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var servicesAdmin = {};
                    servicesAdmin = snapshot.val();
                    dispatch(setServicesAdmin(servicesAdmin));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setServicesAdmin(null));
                }
            })
            .catch(err => {
                console.log ('Error getting services: ', err);
                dispatch(setServicesAdmin(null));
        });
    };
};